module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/newyorktimes-328a94842d322c78c417710ef1326e6e.png";